module.exports = __webpack_public_path__ + "static/media/ps-consultants.9c4568a9.png";